export default __webpack_public_path__ + "static/4-d80614fbe1d4a29fb7443761611ec134.jpeg";